import { planTypes } from "@/common/constants";

export default {
  data () {
    return {
      title: this.$t('billing.cmr.title'),
      subtitle: '',
      description: this.$t('billing.cmr.desc'),
      logo: require('@/assets/plans/cloud.svg'),
      planType: planTypes.CMR,
    }
  }
};
